export default __webpack_public_path__ + "9ec95e46c1a577bcef7bf0d485cfefd4.svg";